import { graphql } from 'gatsby';
// eslint-disable-next-line no-restricted-imports
import type { CustomDrupal, I18n } from '@lucid/utils';

const getLinkPath = (url: CustomDrupal.Url | null | undefined, languageKey: I18n.AvailableLanguagesKey) => {
  let linkPath = '';
  if (url?.entity?.entityTranslations) {
    linkPath = url.entity.entityUrl.path;
    const nodes = url.entity!.entityTranslations;

    // find a language match that is published
    const node = nodes.find(({ langcode, status }) => languageKey === (langcode || {}).value && status);

    if (node && node.entityUrl && node.entityUrl.path) {
      linkPath = node.entityUrl.path;
    }
  }

  return linkPath || (url || {}).path || '';
};

export const getLinkPathFragment = graphql`
  fragment getLinkPath on Drupal_Url {
    path
    ... on Drupal_EntityCanonicalUrl {
      entity {
        entityUrl {
          path
        }
        entityTranslations {
          ... on Drupal_Node {
            langcode {
              value
            }
            status
            entityUrl {
              path
            }
          }
        }
      }
    }
  }
`;

export const getChartLinkPathFragment = graphql`
  fragment getChartLinkPath on ChartDrupal_Url {
    path
    ... on ChartDrupal_EntityCanonicalUrl {
      entity {
        entityUrl {
          path
        }
        entityTranslations {
          ... on ChartDrupal_Node {
            langcode {
              value
            }
            status
            entityUrl {
              path
            }
          }
        }
      }
    }
  }
`;

export default getLinkPath;
